/* cf-gate-hinge-latch.js
 * Click Fencing - show clearly which end of the gate hinges and which end latches.
 * Pete 2026-08-28: "its a bit tricky to see where the gate hinges and where it latches.
 * make sure this is clear on all calculators."
 *
 * What was there (measured on live 2026-08-28):
 *   blade     hinges = two 8x10 rects fill #444444 at the gate edge; latch = ONE 3x7.2
 *             rect fill #999 - about 1.9 CSS px wide once the drawing is scaled. Invisible.
 *   flat top  hinges = two 8x17 rects fill #1a1a1a; latch = one 8x27 rect fill #555.
 *   PerfMesh  same as flat top, and on the OPPOSITE side - so the side must never be
 *             assumed, it has to be read off the drawing.
 *   glass     no hardware is drawn at all; the gate hangs off the "Hinge" panel, which is
 *             the panel next to it, so the side is read from the panel order. Verified
 *             against the LHS/RHS Hinge control: switching it reorders the panels.
 *
 * What it does: redraws the hardware so it reads at a glance - two BLUE knuckles on the
 * hinge edge, one larger ORANGE latch mid-height on the other. No words: Pete asked for
 * the HINGES / LATCH text to come off (2026-08-28), so the shape carries the meaning -
 * a pair at one edge is a hinge, a single block at handle height is a latch.
 *
 * Hinges always come as a PAIR and the latch is always SINGLE - that is what identifies
 * which is which, on every calculator, whichever side the gate is hung.
 *
 * TWO GUARDS, both added after Pete caught the latch mark sitting at the FOOT of the hinge
 * post on a mesh quote (2026-08-28) while the real latch went unmarked:
 *   1. a candidate only counts as hardware if it sits in the middle band of the drawing -
 *      a base plate, bracket or gate stop on the ground line is not hardware;
 *   2. the latch must be a gate's width away from the hinges AND at the same height as
 *      them. If nothing qualifies, the hinges are still marked and the latch is left
 *      alone - never guess it.
 *
 * Display only - touches no price, product, quantity or cart line.
 */
(function () {
  if (window.__cfGateHingeLatchPatched) return;
  window.__cfGateHingeLatchPatched = true;

  var NS = 'http://www.w3.org/2000/svg';

  // the mesh preview's viewBox carries a y OFFSET ("-27.4 18.0 1881.8 177.9"), so the
  // vertical band has to be measured from vb.y, not from zero
  function vbBand(svg) {
    var vb = (svg.getAttribute('viewBox') || '').split(/\s+/).map(Number);
    if (vb.length !== 4 || !vb[3]) return null;
    return { y: vb[1], h: vb[3] };
  }

  var HINGE_COLOUR = '#0e9ed5';   // same blue the calculators already use to highlight a gate
  var LATCH_COLOUR = '#ea580c';
  var HARDWARE_FILL = /^#(444|444444|555|555555|666|666666|888|888888|999|999999|aaa|aaaaaa|1a1a1a)$/;

  /* ---------- blade / flat top / PerfMesh: SVG ---------- */

  function markers(svg) {
    var out = [];
    var rects = svg.querySelectorAll('rect');
    for (var i = 0; i < rects.length; i++) {
      var r = rects[i];
      if (r.getAttribute('data-cf-gate')) continue;
      var o = {
        x: parseFloat(r.getAttribute('x')),
        y: parseFloat(r.getAttribute('y')),
        w: parseFloat(r.getAttribute('width')),
        h: parseFloat(r.getAttribute('height')),
        f: (r.getAttribute('fill') || '').toLowerCase()
      };
      // a post is the same colour but full height; a base plate is wider; a picket is #000
      if (!(o.w > 0 && o.w <= 12 && o.h >= 4 && o.h <= 45)) continue;
      if (!HARDWARE_FILL.test(o.f)) continue;
      out.push(o);
    }
    return out;
  }

  function doSvg(svg) {
    if (!svg.querySelector('text')) return;
    var cand = markers(svg);
    if (!cand.length) return;

    var cols = {}, i;
    for (i = 0; i < cand.length; i++) {
      var k = Math.round(cand[i].x / 2) * 2;
      (cols[k] = cols[k] || []).push(cand[i]);
    }
    var keys = Object.keys(cols).map(Number).sort(function (a, b) { return a - b; });
    var band = vbBand(svg);
    var vbH = band ? band.h : 0, vbY = band ? band.y : 0;
    function cy(list) {
      var t = 1e9, b = -1e9, k;
      for (k = 0; k < list.length; k++) {
        if (list[k].y < t) t = list[k].y;
        if (list[k].y + list[k].h > b) b = list[k].y + list[k].h;
      }
      return (t + b) / 2;
    }
    // gate hardware sits in the middle band of the drawing. A post base plate, a bracket
    // or a gate stop down on the ground line is NOT hardware, and colouring one orange is
    // exactly the bug Pete caught on 2026-08-28: the latch mark landed at the foot of the
    // hinge post while the real latch went unmarked.
    function inHardwareBand(c) { return vbH > 0 && c > vbY + vbH * 0.15 && c < vbY + vbH * 0.8; }

    var hinge = [], latch = [];
    for (i = 0; i < keys.length; i++) {
      var col = cols[keys[i]];
      if (!inHardwareBand(cy(col))) continue;
      (col.length >= 2 ? hinge : latch).push(keys[i]);
    }
    if (!hinge.length) return;

    var fs = 11, texts = svg.querySelectorAll('text');
    for (i = 0; i < texts.length; i++) {
      var v = parseFloat(texts[i].getAttribute('font-size') || 0);
      if (v > fs) fs = v;
    }

    var sig = fs + '|' + cand.map(function (o) { return o.x + ',' + o.y; }).join(';');
    if (svg.__cfGateSig === sig && svg.querySelector('[data-cf-gate]')) return;
    svg.__cfGateSig = sig;

    var old = svg.querySelectorAll('[data-cf-gate]');
    for (i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);

    function mark(o, col, pad) {
      var r = document.createElementNS(NS, 'rect');
      r.setAttribute('x', o.x - pad); r.setAttribute('y', o.y - pad);
      r.setAttribute('width', o.w + 2 * pad); r.setAttribute('height', o.h + 2 * pad);
      r.setAttribute('rx', 1.5); r.setAttribute('fill', col);
      r.setAttribute('data-cf-gate', '1');
      svg.appendChild(r);
    }
    hinge.forEach(function (hx) {
      var hs = cols[hx], j;
      var hCy = cy(hs);
      // the latch is on the OTHER side of the gate and at the same height as the hinges
      var l = null, best = 1e9;
      latch.forEach(function (lx) {
        var d = Math.abs(lx - hx);
        if (d < 30 || d > 420) return;                       // not a gate's width apart
        if (Math.abs(cy(cols[lx]) - hCy) > vbH * 0.2) return; // not at hardware height
        if (d < best) { best = d; l = lx; }
      });
      for (j = 0; j < hs.length; j++) mark(hs[j], HINGE_COLOUR, 2);
      if (l === null) return;   // mark the hinges, never guess the latch
      var ls = cols[l];
      for (j = 0; j < ls.length; j++) mark(ls[j], LATCH_COLOUR, 3.5);
    });
  }

  /* ---------- glass: HTML panels ---------- */

  function doGlass(container) {
    var panels = container.querySelectorAll('.panel-preview');
    if (panels.length < 2) return;
    var gateIx = -1, hingeIx = -1, i;
    for (i = 0; i < panels.length; i++) {
      var txt = (panels[i].textContent || '');
      // no \b here: the panel's textContent concatenates its label divs with no
      // separator, so the gate reads "800Gate" and the hinge panel "1700Hinge"
      if (/Gate/.test(txt)) gateIx = i;
      else if (/Hinge/.test(txt)) hingeIx = i;
    }
    if (gateIx < 0) return;
    // no hinge panel drawn: fall back to the panel the gate sits against
    var hingeOnLeft = hingeIx >= 0 ? hingeIx < gateIx : gateIx > 0;

    var gate = panels[gateIx];
    var box = gate.children[0];
    if (!box) return;
    var sig = gateIx + '|' + hingeOnLeft + '|' + box.clientWidth + 'x' + box.clientHeight;
    var existing = gate.querySelector('[data-cf-gate]');
    if (existing && existing.getAttribute('data-cf-sig') === sig) return;
    var old = gate.querySelectorAll('[data-cf-gate]');
    for (i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);

    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var ov = document.createElement('div');
    ov.setAttribute('data-cf-gate', '1');
    ov.setAttribute('data-cf-sig', sig);
    ov.style.cssText = 'position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;z-index:5;';

    function block(side, topPct, heightPct, col, w) {
      var b = document.createElement('div');
      b.style.cssText = 'position:absolute;top:' + topPct + '%;height:' + heightPct + '%;' + side +
        ':1px;width:' + w + 'px;background:' + col + ';border-radius:2px;';
      ov.appendChild(b);
    }
    function knuckles(side) { block(side, 20, 14, HINGE_COLOUR, 7); block(side, 60, 14, HINGE_COLOUR, 7); }
    function latch(side)    { block(side, 38, 20, LATCH_COLOUR, 7); }
    // two blue knuckles on the hinge edge, one orange latch mid-height on the other
    knuckles(hingeOnLeft ? 'left' : 'right');
    latch(hingeOnLeft ? 'right' : 'left');
    box.appendChild(ov);
  }

  /* ---------- driver ---------- */

  var queued = false;
  function apply() {
    queued = false;
    var svgs = document.querySelectorAll('svg');
    for (var i = 0; i < svgs.length; i++) { try { doSvg(svgs[i]); } catch (e) {} }
    var cs = document.querySelectorAll('.panels-container');
    for (var j = 0; j < cs.length; j++) { try { doGlass(cs[j]); } catch (e) {} }
  }
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; apply(); }, 0);
  }

  try {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true, subtree: true, characterData: true
    });
  } catch (e) {}

  // Permanent safety net, deliberately not time-limited. Verified 2026-08-28 on blade:
  // flipping the gate hinge side redraws the preview into a BRAND NEW <svg>, and the
  // MutationObserver did not fire a pass that caught it - the drawing showed hinges on
  // the left while the annotation still read the old right-hand geometry. A single DOM
  // poke fixed it instantly, so the work is right and only the trigger was missed. The
  // pass is a few querySelectorAll calls over a small subtree, so running it for the
  // life of the page costs nothing and a customer can sit on this page for minutes.
  setInterval(apply, 1200);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  apply();
  console.log('[cf-gate-hinge-latch] installed');
})();
